import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CalendarDay } from './MyIbeCalendarDay';
import { MyIbeCalenderRestrictions } from './MyIbeCalenderRestrictions';
export const MyIbeCalenderView = (props) => {
    const { month, translation } = props;
    const { dayOptions, onDayClick, onDayHover } = props;
    const getMonthRestrictions = (key) => {
        // TODO simplify (findWeekWithRestriction ==> find DayWithRestriction) OR 'cache' with useMemo
        return Object.values(month)
            .some((week) => Object.values(week)
            .some((day) => {
            let restricted = false;
            if (day) {
                const restriction = day.restrictions[key];
                if (restriction !== null) {
                    // !!!use THIS older syntax. my-ibe does not like the other!!!
                    restricted = restricted || (typeof restriction === 'number' && restriction > 0);
                    restricted = restricted || (typeof restriction === 'boolean' && restriction);
                }
            }
            return restricted;
        }));
    };
    const restrictions = [
        {
            name: translation.minStay,
            className: 'ibe-min-los-restriction',
            show: getMonthRestrictions('minLengthOfStay'),
        },
        {
            name: translation.maxStay,
            className: 'ibe-max-los-restriction',
            show: getMonthRestrictions('maxLengthOfStay'),
        },
        {
            name: translation.closedForArrival,
            className: 'ibe-closed-arrival',
            show: getMonthRestrictions('closedOnArrival'),
        },
        {
            name: translation.closedForDeparture,
            className: 'ibe-closed-departure',
            show: getMonthRestrictions('closedOnDeparture'),
        },
        {
            name: translation.closed,
            className: 'ibe-closed',
            show: getMonthRestrictions('closed'),
        },
    ];
    return (_jsxs("div", { className: "ibe-calendar ibe-calendar-view", children: [_jsxs("div", { className: "ibe-calendar-header", children: [_jsx("span", { children: translation.dayLabel.monday }), _jsx("span", { children: translation.dayLabel.tuesday }), _jsx("span", { children: translation.dayLabel.wednesday }), _jsx("span", { children: translation.dayLabel.thursday }), _jsx("span", { children: translation.dayLabel.friday }), _jsx("span", { children: translation.dayLabel.saturday }), _jsx("span", { children: translation.dayLabel.sunday })] }), _jsx("div", { className: "ibe-calendar-rows", children: Object.entries(month).map(([week, days]) => {
                    return (_jsx("div", { className: "ibe-calendar-row", children: Object.entries(days).map(([weekDay, day]) => {
                            const options = dayOptions(day);
                            return (_jsx("div", { className: "ibe-calendar-day-wrapper", children: _jsx(CalendarDay, { day: day, onClick: onDayClick, onHover: onDayHover, options: options }) }, `day-${weekDay}`));
                        }) }, `week-${week}`));
                }) }), _jsx(MyIbeCalenderRestrictions, { restrictions: restrictions })] }));
};
//# sourceMappingURL=MyIbeCalenderView.js.map